import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import EmailResponseFormExistingUser from './emailResFormExistUser';
import EmailResponseFormGuestUser from './emailResFormGuestUser';
import { EmailVerification } from '../../../../../../components/form';
import { get, isEmpty } from '../../../../../../utils/lodash';

// TODO: Implement only get data when confirmed the button
// separate response panel
/**
 * Only get data when confirmed the button
 */
function CheckUserEmail(props) {
  const { t } = useTranslation();
  const {
    checkChangeAllow = null,
    isRootOrgOwned = true,
    activityManager = null,
    changeOwnershipPayload = {
      fromUserId: null,
    },
    setFieldValue,
  } = props;

  // assign founded user from verifying
  const [foundedUser, setFoundedUser] = useState(null);

  // assign user after confirmed
  const [attachedUser, setAttachedUser] = useState(activityManager);

  // TODO: need to investigate this is not working Formik issue
  // const RenderResponsePanel = props => {
  //   if (attachedUser) {
  //     return <EmailResponseFormGuestUser {...props} />;
  //   } else {
  //     if (foundedUser && foundedUser.isExitingUser) {
  //       const { data } = foundedUser;
  //       console.log(
  //         '🚀 ~ file: checkUserEmail.js:41 ~ RenderResponsePanel ~ data:',
  //         data
  //       );
  //       const isFeatureMet =
  //         !activityFeatureRequired ||
  //         (activityFeatureRequired &&
  //           !isEmpty(data.userFeatures) &&
  //           data.userFeatures.includes(activityFeatureRequired));

  //       const toOrganisationId = data.organisationId;
  //       const {
  //         fromOrganisationId = null,
  //         // toOrganisationId = null,
  //         parentActOwnerOrgId = null,
  //       } = changeOwnershipPayload;

  //       const isChangAllowedMet =
  //         !checkChangeAllow ||
  //         (checkChangeAllow &&
  //           (fromOrganisationId === toOrganisationId ||
  //             toOrganisationId === parentActOwnerOrgId ||
  //             fromOrganisationId === parentActOwnerOrgId));

  //       if (!isChangAllowedMet) {
  //         return (
  //           <>
  //             <div className="no-feature-warning-box w-100">
  //               <div className="padding-issue ">
  //                 You can not not invite this user to this activity. This
  //                 organisation is not matched
  //               </div>
  //             </div>
  //           </>
  //         );
  //       } else if (!isFeatureMet) {
  //         return (
  //           <>
  //             <div className="no-feature-warning-box w-100">
  //               <div className="padding-issue ">
  //                 Invitation to this activity is not possible for the user in
  //                 question as the activity type is not accessible or available
  //                 to them
  //               </div>
  //             </div>
  //           </>
  //         );
  //       } else if (isChangAllowedMet && isFeatureMet) {
  //         return <EmailResponseFormExistingUser />;
  //       }
  //     } else if (foundedUser && !foundedUser.isExitingUser) {
  //       return (
  //         <>
  //           <span className="not-verified-email">
  //             This email does not match an existing account in Takso. Enter
  //             details below to create a guest account for this person
  //           </span>

  //           <CustomInput
  //             id="firstName"
  //             name="firstName"
  //             placeholder="Enter First Name 1"
  //             labelText="First Name"
  //             requiredStar
  //           />
  //           <EmailResponseFormGuestUser {...props} />
  //         </>
  //       );
  //     }
  //   }
  //   return <></>;
  // };

  let data = null;
  if (foundedUser) {
    let { data: userData } = foundedUser;
    data = userData;
  }

  // TAK-2040: a guest may own any linked activity type (Single or Program)
  // as long as the true root ancestor of the parent is organisation-owned —
  // resolved server-side and passed down as isRootOrgOwned. This replaces
  // the previous per-user feature-flag/activity-type matrix.
  const isFeatureMet = isRootOrgOwned;

  const { fromUserId = null } = changeOwnershipPayload;

  // TAK-2040b: ownership-change authorization is enforced server-side (the
  // caller must be the activity's direct parent owner, or the true root
  // owner as a back-up) — organisation matching between the outgoing and
  // incoming owner is no longer a gate here.
  const isChangAllowedMet = true;

  const resetUserDefaultValues = () => {
    setFieldValue('firstName', '');
    setFieldValue('surname', '');
    setFieldValue('entityName', '');
    setFieldValue('address1', '');
    setFieldValue('address2', '');
    setFieldValue('phone', '');
    setFieldValue('suburb', '');
    setFieldValue('state', '');
    setFieldValue('postcode', '');
  };

  const onChangeUserData = (userData) => {
    setFoundedUser(userData);
    setAttachedUser(null);
    resetUserDefaultValues();
    setFieldValue(
      'isExistingUser',
      !isEmpty(userData) ? userData.isExitingUser : false
    );

    // TAK-2040: same structural rule as isFeatureMet above.
    const _isFeatureMet = isRootOrgOwned;

    if (checkChangeAllow) {
      // TAK-2040b: organisation matching is no longer a gate — server-side
      // authorization (parent owner or root owner) is the real check.
      // if new user allow to change
      if (userData && !userData.isExitingUser) {
        setFieldValue('isChangeAllowed', true);
      } else {
        const toUserId = get(userData, 'data.id', null);
        // check same user is truing to add as new user
        if (_isFeatureMet && fromUserId !== toUserId) {
          setFieldValue('isChangeAllowed', userData && !isEmpty(userData));
        } else {
          setFieldValue('isChangeAllowed', false);
        }
      }
    } else {
      if (_isFeatureMet) {
        setFieldValue('isChangeAllowed', userData && !isEmpty(userData));
      } else {
        setFieldValue('isChangeAllowed', false);
      }
    }
    setFieldValue('isConfirmedUser', userData && !isEmpty(userData));
    // to get organisation
    setFieldValue(
      'organisationId',
      get(userData, 'data.organisation.id', null)
    );
  };

  return (
    <>
      <EmailVerification
        id="email"
        name="email"
        getData={onChangeUserData}
        {...props}
      />

      {/* Render Response */}
      {/* attached user data coming for editing || setting default values */}
      {attachedUser ? (
        <>
          {get(attachedUser, 'isExistingUser', false) ? (
            <EmailResponseFormExistingUser data={attachedUser} />
          ) : (
            <EmailResponseFormGuestUser {...props} />
          )}
        </>
      ) : foundedUser &&
        checkChangeAllow &&
        fromUserId === get(foundedUser, 'data.id', null) ? (
        <div className="no-feature-warning-box w-100">
          <div className="padding-issue ">
            {t(
              'activity.activity_plan.linked_activity.you_cannot_invite_to_same_user_again'
            )}
          </div>
        </div>
      ) : !isFeatureMet && foundedUser ? (
        <>
          <div className="no-feature-warning-box w-100">
            <div className="padding-issue ">
              {t(
                'activity.activity_plan.linked_activity.invitation_activity_type_not_accessible'
              )}
            </div>
          </div>
        </>
      ) : isFeatureMet ? (
        foundedUser && !foundedUser.isExitingUser ? (
          <>
            <span className="not-verified-email">
              {t(
                'activity.activity_plan.linked_activity.this_email_does_not_match_an_existing_account_in_takso_enter_details_below_to_create_a_guest_account_for_this_person'
              )}
            </span>

            <EmailResponseFormGuestUser {...props} />
          </>
        ) : foundedUser && foundedUser.isExitingUser ? (
          <EmailResponseFormExistingUser
            data={get(foundedUser, 'data', null)}
          />
        ) : (
          <></>
        )
      ) : (
        <></>
      )}
    </>
  );
}

export default CheckUserEmail;
